export const HALF_HOUR_STEP_MINUTES = 30;

// Sessions never cross midnight (spec Assumptions) — every computed end caps here.
export const END_OF_DAY_MINUTES = 23 * 60 + 59;

// Matches `CLIENT_SEARCH_DEBOUNCE_MS` in `features/client/search-client/config/search.ts`,
// restated because a feature cannot import another feature's internals.
export const CLIENT_SEARCH_DEBOUNCE_MS = 250;
